export default {
  'component.loanapplication.title': 'Lånesøknader',
  'component.loanapplication.exportascsv': 'Eksporter som CSV',
  'component.loanapplication.exportasexcel': 'Eksporter som Excel',
  'component.loanapplication.exportaspdf': 'Eksporter som PDF',
  'component.loanapplication.printall': 'Skriv ut alle',
  'component.loanapplication.tablesearch':
    'Søk etter alternativ, navn, e-post, telefon og pantelån',
};
